import styled, { css } from 'styled-components';

import Icon from '~/src/common/components/Icon';
import { COLORS } from '~/src/common/theme';

import ButtonBase from './BaseButton';

export const buttonStyleSecondary = css`
  & ${Icon} {
    color: ${COLORS.ACTION_DEFAULT};
  }

  &:disabled {
    color: ${COLORS.NEUTRAL_DISABLED};
    background: ${COLORS.NEUTRAL_WHITE};
    border-color: ${COLORS.NEUTRAL_DISABLED};

    & ${Icon} {
      color: ${COLORS.NEUTRAL_DISABLED};
    }
  }

  &:not(:disabled) {
    color: ${COLORS.ACTION_DEFAULT};
    background: ${COLORS.NEUTRAL_WHITE};
    border-color: ${COLORS.ACTION_DEFAULT};

    &:hover {
      color: ${COLORS.ACTION_HOVER};
      background: ${COLORS.NEUTRAL_WHITE};
      border-color: ${COLORS.ACTION_HOVER};

      & ${Icon} {
        color: ${COLORS.ACTION_HOVER};
      }
    }
  }

  &:disabled [role='status'] {
    border-color: ${COLORS.NEUTRAL_STROKE};
    border-right-color: ${COLORS.NEUTRAL_DISABLED};
  }
`;

const SecondaryButton = styled(ButtonBase)`
  ${buttonStyleSecondary}
`;

export default SecondaryButton;
